
import PRM from "@/core/PermissionConstants";
import  RouteConstants  from "@/app/core/RouteConstants";

export default {
    path: RouteConstants.SCREEN_TURN.path,
    name: RouteConstants.SCREEN_TURN.name,
    component: () => import("@/app/views/turns/ScreenTurnView.vue"),
    meta: {
    //   service: () => import("@/app/services/WebServicesService"),
    //   table: () => import("@/app/components/config/webServices/WebServicesTable.vue"),
    //   form: () => import("@/app/components/config/webServices/WebServicesForm.vue"),
      header: {
        icono: "mdi-search-web",
        texto: "Servicios web",
        textNew: "Nuevo servicio web",
        textEdit: "Editar servicio web",
      },
    //   prmAdd: PRM.ADD_WEB_SERVICE,
    //   requireAuth: true,
    //   hideButtonAdd: false,
    //   addButtonText: "AGREGAR SERVICIO WEB",
    },
  };